import { useAxios } from '../context/AxiosContext';
import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { LOCATION } from '../constants/locales';

export function useGetStates() {
  const { authAxios } = useAxios();

  const fetchStates = useCallback(
    async (location: string) => {
      const { data } = await authAxios.get(`/states/${location}`);
      return data.map(({ stateName, stateCd }) => ({ label: stateName, value: stateCd }));
    },
    [authAxios]
  );

  return useQuery(['states'], () => fetchStates(LOCATION), {
    refetchOnWindowFocus: false
  });
}
